import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Layout, Text } from '@humanspace/components';
import { Colors, Spacing } from '@humanspace/foundations';
import { getAccounts, setAccountId } from '../../services';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
`;

const AccountCard = styled.button`
  width: 100%;
  padding: ${Spacing.l};
  margin-bottom: ${Spacing.m};
  background: rgba(255, 255, 255, 0.08);
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: ${Colors.primary};
    background: rgba(255, 255, 255, 0.12);
  }
`;

const AccountName = styled(Text)`
  color: ${Colors.white};
`;

const StyledText = styled(Text)`
  margin-bottom: ${Spacing.xl};
  color: rgba(255, 255, 255, 0.7);
`;

const SelectAccount = () => {
  const history = useHistory();
  const accounts = getAccounts();

  const handleSelect = account => {
    setAccountId(account.id);
    history.push('/projects');
  };

  return (
    <Layout
      render={
        <Wrapper>
          <Text size="xl" bold style={{ marginBottom: Spacing.m }}>
            Select Account
          </Text>
          <StyledText size="m">
            Choose which account to work in.
          </StyledText>
          {accounts.map(account => (
            <AccountCard key={account.id} onClick={() => handleSelect(account)}>
              <AccountName size="l" bold>
                {account.name}
              </AccountName>
            </AccountCard>
          ))}
        </Wrapper>
      }
    />
  );
};

export default SelectAccount;
